import { ChatParticipantType } from './chat-participant-type';

export class ChatMessage {
   public constructor(public text: string, public sender: ChatParticipantType) {
      // nothing to do
   }
}
